module.exports = __webpack_public_path__ + "img/imgZXGH(5).426e18af.png";